/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormDataDto } from './formDataDto';


export interface ConfigFormDataModificationResultDto { 
    modifiedFormData?: FormDataDto;
    configStatus?: ConfigFormDataModificationResultDto.ConfigStatusEnum;
    itemStatus?: ConfigFormDataModificationResultDto.ItemStatusEnum;
    version?: number;
}
export namespace ConfigFormDataModificationResultDto {
    export const ConfigStatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        ConfirmedBySales: 'CONFIRMED_BY_SALES',
        ReadyForProduction: 'READY_FOR_PRODUCTION',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type ConfigStatusEnum = typeof ConfigStatusEnum[keyof typeof ConfigStatusEnum];
    export const ItemStatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type ItemStatusEnum = typeof ItemStatusEnum[keyof typeof ItemStatusEnum];
}


export type ConfigStatusEnum = typeof ConfigFormDataModificationResultDto.ConfigStatusEnum[keyof typeof ConfigFormDataModificationResultDto.ConfigStatusEnum];
export type ItemStatusEnum = typeof ConfigFormDataModificationResultDto.ItemStatusEnum[keyof typeof ConfigFormDataModificationResultDto.ItemStatusEnum];
